module.exports = __webpack_public_path__ + "assets/img/02.320d3bf8.png";